import React, { useState, useEffect } from "react";
import { putLocalidad } from "../helpers/rutaLocalidades";
import { getProvincias } from "../helpers/rutaProvincias";
import { getDeptos } from "../helpers/rutaDeptos";
import { Modal, Button } from "react-bootstrap";
import "animate.css";

const ModalFormLocalidad = ({ localidad, handleClose }) => {
  const [showSuccess, setShowSuccess] = useState(false);

  const data = localidad?.localidades || localidad || {};

  const [formValues, setFormValues] = useState({
    localidad: "",
    codpostal: "",
    codprov: "",
    coddept: "",
  });

  const [provincias, setProvincias] = useState({
    data: { provincias: [] },
    loading: true,
  });

  const [deptos, setDeptos] = useState({
    data: { deptos: [] },
    loading: true,
  });

  useEffect(() => {
    setFormValues({
      localidad: data?.localidad || "",
      codpostal: data?.codpostal ?? data?.codigopostal ?? "",
      codprov: String(
        data?.codprov ??
          data?.provincia?.codprov ??
          ""
      ),
      coddept: String(
        data?.coddept ??
          data?.depto?.coddept ??
          ""
      ),
    });
  }, [localidad]);

  useEffect(() => {
    getProvincias().then((resp) => {
      setProvincias({
        data: resp || { provincias: [] },
        loading: false,
      });
    });

    getDeptos().then((resp) => {
      setDeptos({
        data: resp || { deptos: [] },
        loading: false,
      });
    });
  }, []);

  const handleChange = (e) => {
    setFormValues((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const id = data?._id || localidad?._id;
    if (!id) {
      alert("No se encontró el id de la localidad");
      return;
    }

const deptoSeleccionado = (deptos.data?.deptos || []).find(
  (d) => String(d.coddept) === String(formValues.coddept)
);

const provinciaSeleccionada = (provincias.data?.provincias || []).find(
  (p) => String(p.codprov) === String(formValues.codprov)
);

    const payload = {
      localidad: formValues.localidad,
      codpostal: formValues.codpostal,

      codprov: Number(formValues.codprov),
      coddept: Number(formValues.coddept),

      provincia: provinciaSeleccionada?._id || null,
      depto: deptoSeleccionado?._id || null,
    };

    console.log("📦 Payload localidad:", payload);
    
    try {
      const resp = await putLocalidad(id, payload);
      console.log("✅ Localidad actualizada:", resp);

      if (resp?.ok === false) {
        alert(resp?.error?.message || resp?.error || "No se pudo actualizar la localidad");
        return;
      }

      setShowSuccess(true);

      setTimeout(() => {
        setShowSuccess(false);
        handleClose();
      }, 2000);
    } catch (error) {
      console.error("❌ Error al guardar localidad:", error);
      alert("Error al guardar localidad");
    }
  };

  if (provincias.loading || deptos.loading) {
    return <div className="p-3">Cargando...</div>;
  }

  return (
    <>
      <form onSubmit={handleSubmit}>
        <Modal.Body>
          <div className="form-group mt-3">
            <label>Localidad</label>
            <input
              type="text"
              className="form-control"
              name="localidad"
              maxLength="50"
              minLength="2"
              required
              value={formValues.localidad}
              onChange={handleChange}
            />
          </div>

          <div className="form-group mt-3">
            <label>Cod Postal</label>
            <input
              type="text"
              className="form-control"
              name="codpostal"
              maxLength="10"
              required
              value={formValues.codpostal}
              onChange={handleChange}
            />
          </div>

          <div className="form-group mt-3">
            <label>Departamento</label>
            <select
              className="form-control"
              name="coddept"
              value={formValues.coddept}
              onChange={handleChange}
              required
            >
              <option value="">Elija la opción adecuada</option>
              {(deptos.data?.deptos || [])
                .filter((d) => d?.activo ?? true)
                .sort((a, b) =>
                  (a.depto || "").localeCompare(b.depto || "", "es", {
                    sensitivity: "base",
                  })
                )
                .map((depto) => (
                  <option key={depto._id} value={String(depto.coddept)}>
                    {depto.depto}
                  </option>
                ))}
            </select>
          </div>

          <div className="form-group mt-3">
            <label>Provincia</label>
            <select
              className="form-control"
              name="codprov"
              value={formValues.codprov}
              onChange={handleChange}
              required
            >
              <option value="">Elija la opción adecuada</option>
              {(provincias.data?.provincias || [])
                .filter((p) => p?.activo ?? true)
                .sort((a, b) =>
                  (a.provincia || "").localeCompare(b.provincia || "", "es", {
                    sensitivity: "base",
                  })
                )
                .map((provincia) => (
                  <option key={provincia._id} value={String(provincia.codprov)}>
                    {provincia.provincia}
                  </option>
                ))}
            </select>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button type="submit" variant="dark">
            Guardar
          </Button>
        </Modal.Footer>
      </form>

      <Modal
        show={showSuccess}
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="animate__animated animate__fadeInDown"
      >
        <Modal.Body className="text-center">
          <div style={{ fontSize: "3rem" }}>🖐</div>
          <h5 className="mt-2">¡Cambios guardados correctamente!</h5>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalFormLocalidad;